import jwtInterceptor from "@/shared/jwtInterceptor";

const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

export class OperatorsApi
{
  static async getOperatorsItems()
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getOperatorItems';
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

  static async getUserSingleForEdit(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getUserSingleForEdit/'+id;
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }
  static async getMarketRequestSingleForEdit(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getMarketRequestSingleForEdit/'+id;
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

  static async getAuctionRequestSingleForEdit(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getAuctionRequestSingleForEdit/'+id;
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

  static async getRegisterProductRequestSingleForEdit(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getRegisterProductRequestSingleForEdit/'+id;
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

  static async getTicketSingleForEdit(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getTicketSingleForEdit/'+id;
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

  static async getSpecialRequestSingleForEdit(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/getSpecialRequestSingleForEdit/'+id;
      const response = await jwtInterceptor.get(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

  static async unlockUserRegisterLock(id)
  {
    try
    {
      const url = apiUrl + 'admin/Operators/unlockUserRegisterLock/'+id;
      const response = await jwtInterceptor.post(url);
      if (response && response.data)
      {
        return response.data
      }
    }
    catch (e)
    {}
    return null;
  }

}
